import React, { Component } from 'react';
import Icon from 'components/common/Icon';
import isObject from 'lodash/isObject';
import has from 'lodash/has';

export default class EventList extends Component {

  render() {
    const { event, onSelect, drawDivider, showChevron } = this.props;

    if (!event || !event.id) {
      return <div></div>;
    }

    const timeFormat = has(this.props, 'timeFormat') ? this.props.timeFormat : 'start_time';

    let time = <span>All Day</span>;
    let description;

    if (event.labels.start_time) {
      if(timeFormat == 'start_time') {
        time = event.labels.start_time;
      } else if(timeFormat == 'start_date') {
        time = event.labels.start_moment.format('Do ddd');
      }
    }

    let displayClass = 'data';

    if (event.status.id === 2 || event.status.id === 6 || event.status.id === 7) {
      displayClass += ' cancelled';
    } else if (event.status.id === 3) {
      displayClass += ' tentative';
    } else if (event.status.id === 5) {
      displayClass += ' awaiting-approval';
    }

    if (event.type.id === 2 || event.type.id === 3 || event.type.id === 4) {
      if (event.home_away && event.home_away.length) {
        description = (
          <div className="subtext">
            {event.home_away.map((homeAway, key) => {
              if (isObject(homeAway.school_id)) {
                const schoolName = unescape(homeAway.school_id.name);
                if (key < event.home_away.length - 1) {
                  return `${schoolName}, `;
                }
                return schoolName;
              } else if (isObject(homeAway.group_id)) {
                const groupName = unescape(homeAway.group_id.name);
                if (key < event.home_away.length - 1) {
                  return `${groupName}, `;
                }
                return groupName;
              }
              return null;
            })}
          </div>
        );
      }
    } else {
      if (event.locations && event.locations.length) {
        description = (
          <div className="subtext">
            {event.locations.map((loc, key) => {
              if (key < event.locations.length - 1) {
                return (<span key={key} dangerouslySetInnerHTML={{ __html: `${loc.name}, ` }} />);
              }
              return (<span key={key} dangerouslySetInnerHTML={{ __html: loc.name }} />);
            })}
          </div>
        );
      }
    }

    /* eslint react/jsx-no-bind: 0 */
    const renderItem = () => (
      <div className="list-item clickable" onClick={onSelect.bind(null, event)}>
        <div className="inner">
          <div className="icon">{time}</div>
          <div className={displayClass}>
            {event.name}
            {description}
          </div>
        </div>

        {showChevron && (
          <Icon icon="arrow" className="link-indicator" />
        )}

        {drawDivider && (
          <div className="divider divider-with-icon"></div>
        )}
      </div>
    );

    return (
      <span>
        {renderItem()}
      </span>
    );
  }
}

/* eslint no-console: ["error", { allow: ["info"] }] */
EventList.defaultProps = {
  onSelect: (event) => console.info('Event selected', event.name),
};



// WEBPACK FOOTER //
// ./src/app/components/calendar/EventListItem.js